import React, {  } from 'react';
import './Header.css';
import SASLOGO from './../../assets/hsdm.png';
import HRYLOGO from './../../assets/hkcl.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
const Header = () => {
  

  return (
    <div style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
      <div className='headertop' style={{ padding: '8px 45px', background: 'linear-gradient(150deg,rgb(54, 122, 232) 0%,rgb(107, 150, 194) 100%)',color:"white"}}>
      <span className="me-3"> If you face any difficulty in downloading the admit card, please call us at &nbsp;<FontAwesomeIcon icon={faPhone} className='me-2'/><span className="">0172-5210294 / 5210295</span></span>
      <span className=""> <FontAwesomeIcon icon={faEnvelope} className='me-2' /><span className="">info@hkcl.in</span></span>
      </div>
      <header style={{  position: 'relative',padding:"10px 0" }}>
        <div className='container-fluid'>
          <div className="d-flex align-items-center justify-content-center" style={{position:"relative"}}>
            
            <div className="col-md-1 col-xs-4 text-center"  >
              <img src={HRYLOGO} alt='Right Logo' width={90}  />
            </div>
            <div className="col-md-11 col-xs-8 mt-3">
              <h3 className='mobiletext' style={{  color: '#e51d2a', margin: 0 }}>
            <div className='text-dark fw-bold mobp' style={{textTransform:"uppercase",fontSize:"1.1rem"}}></div>
                <div className='fw-bolder mobp' style={{textTransform:"uppercase",color:"#0b50dd"}}> HKCL Recruitment Exam </div>
                <p className=' fw-bold mobpb' style={{textTransform:"",fontSize:"0.9rem",color:"#898989"}}><>Promoted by Government of Haryana</></p>
              </h3>
            </div>
            {/* <div className="col-md-2 col-xs-4 text-end mobileview" >
              <img src={ HRYLOGO} alt='Department Logo' width={105} />
            </div> */}
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
